module.exports = __webpack_public_path__ + "c2724435e661e47a26a392f897a94721.svg";